import HeaderSm from "components/headers/sm";
import type { LiabilityFormLayout } from "../../types";
import { liabilityNameLayout } from "../name";
import { liabilitySubtypeLayout } from "../subtype";
import { separator } from "../separator";
import { ownership } from "../ownership";



export const step1Layout = (options: { withOwnership?: boolean } = { withOwnership: true }): LiabilityFormLayout => {
  return {
    children: [
      {
        component: () => () => <HeaderSm title="Debt Information" subtitle="Specific details regarding this debt"/>
      },
      {
        children: [
          liabilityNameLayout(),
          liabilitySubtypeLayout(),
          options.withOwnership ? separator() : null,
          options.withOwnership ?  ownership() : null,
        ]
      }
    ]
  }
}
